import { render, staticRenderFns } from "./TreeItems.vue?vue&type=template&id=47a08dce&"
import script from "./TreeItems.vue?vue&type=script&lang=js&"
export * from "./TreeItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports